export const differenceBetweenDateStringsInDays = (
  date1: string,
  date2: string
): number => {
  // @ts-ignore
  const ms = new Date(date1) - new Date(date2);
  return millisecondsToDays(ms);
};

export const millisecondsToDays = (ms: number): number => {
  const dayFactor = 24 * 60 * 60 * 1000;
  const days = Math.floor(ms / dayFactor);
  return days;
};

export const hasDatePassed = (date: Date): boolean => {
  if (date > new Date()) return false;
  return true;
};

export const truncateISOString = (isoString: string): string => {
  if (isoString.length <= 10) return isoString;
  return isoString.slice(0, 10);
};

export const getISOStringOneYearFromToday = (): string => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  return date.toISOString();
};

export const getISOStringOneMonthFromToday = (): string => {
  const date = new Date();
  date.setUTCMonth(date.getUTCMonth() + 1);
  return date.toISOString();
};

export const getMMDDYYForToday = (): string => {
  const date = new Date();
  return getMMDDYYForDate(date);
};

export const getYYYYMMDDForDate = (date: Date): string => {
  const monthNum = date.getUTCMonth() + 1;
  const monthString = monthNum < 10 ? `0${monthNum}` : `${monthNum}`;
  const dayNum = date.getUTCDate();
  const dayString = dayNum < 10 ? `0${dayNum}` : `${dayNum}`;
  const yearString = `${date.getUTCFullYear()}`;
  return yearString + '-' + monthString + '-' + dayString;
};

export const getMMDDYYForDate = (date: Date): string => {
  const monthNum = date.getUTCMonth() + 1;
  const monthString = monthNum < 10 ? `0${monthNum}` : `${monthNum}`;
  const dayNum = date.getUTCDate();
  const dayString = dayNum < 10 ? `0${dayNum}` : `${dayNum}`;
  const yearString = `${date.getUTCFullYear()}`.slice(2);
  return monthString + dayString + yearString;
};

export const getDaysRemainingOnWarrantyFromEndDate = (
  endDate: string | null
): string => {
  if (
    endDate === null ||
    differenceBetweenDateStringsInDays(endDate, new Date().toISOString()) <= 0
  )
    return 'None';
  return (
    differenceBetweenDateStringsInDays(endDate, new Date().toISOString()) +
    ' Days'
  );
};
